import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  Chip,
  Stack,
} from "@mui/material";
import { SearchableState } from "../../../../state/searchable-state";

type Props = {
  label: string;
  column: string;
  searchableState: SearchableState;
  options: { label: string; value: string }[];
};

export const SupportTicketMultiSelectFilter = ({
                                                 label,
                                                 column,
                                                 searchableState,
                                                 options,
                                               }: Props) => {
  const value = searchableState.getFilterValues(column, "IN");

  const handleChange = (event: any) => {
    const values = event.target.value;
    searchableState.onFilters({
      column,
      searchOperator: "IN",
      values,
    });
  };

  return (
    <FormControl size="small" sx={{ width: 220 }}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple
        value={value}
        onChange={handleChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected: string[]) => {
          if (selected.length === 0) return "";

          const firstVal = options.find((o) => o.value === selected[0]);
          const restCount = selected.length - 1;

          return (
            <Stack direction="row" gap={0.5} flexWrap="nowrap">
              <Chip size="small" label={firstVal?.label ?? selected[0]} />
              {restCount > 0 && <Chip size="small" label={`+${restCount}`} />}
            </Stack>
          );
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 300,
              borderRadius: 2,
              boxShadow: 3,
              "& .MuiMenuItem-root": {
                py: 0.3,
                px: 1,
                fontSize: "0.875rem",
              },
              "& .MuiCheckbox-root": {
                p: 0.2,
                mr: 0.7,
                fontSize: "0.875rem",
              },
            },
          },
        }}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value} sx={{ py: 0.3, px: 1 }}>
            <Checkbox
              checked={value.indexOf(opt.value) > -1}
              size="small"
              sx={{ p: 0.2, mr: 0.7 }}
            />
            <ListItemText
              primary={opt.label}
              primaryTypographyProps={{ fontSize: "0.875rem" }}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
